module.exports = __webpack_public_path__ + "img/left_1.0a3deda2.png";